<template>
  <div class="flex flex-col">
    <div
      v-for="(item, index) in data?.cards"
      :key="index"
      class="pb-8 pt-12 even:bg-[#EFFDFF] lg:pt-8"
    >
      <Container class="!max-w-[1472px]">
        <div class="relative flex flex-col lg:flex-row lg:items-start">
          <div class="mb-4 flex shrink-0 flex-col lg:mb-0 lg:basis-[420px]">
            <div
              v-if="item.image?.byline"
              class="pb-2 pr-3 text-right font-sans text-sm lg:order-last lg:pb-0 lg:pl-3 lg:pt-2 lg:text-left"
            >
              {{ item.image?.byline }}
            </div>

            <Image
              v-if="item?.image?.url"
              :url="item.image.url"
              :alt="item.image?.alt"
              class="relative flex aspect-[3/2] h-full overflow-hidden rounded-xl lg:aspect-[1.11] lg:rounded-2xl"
              width="800"
              height="600"
              sizes="xs:100vw sm:400"
              fit="cover"
            />
          </div>

          <div class="flex flex-col lg:items-start lg:justify-start lg:pl-16 xl:pt-16">
            <div class="max-w-4xl">
              <SubTitle class="text-blue">
                {{ item?.subtitle }}
              </SubTitle>
              <h1
                class="mb-6 font-serif text-4xl font-bold leading-none text-black lg:mb-3.5 lg:text-5xl lg:leading-snug"
              >
                {{ item?.title }}
              </h1>
              <div
                v-if="item?.preamble"
                class="mb-6 space-y-6 font-sans text-lg font-normal leading-snug text-black lg:mb-3 lg:space-y-3 lg:text-xl lg:font-bold lg:leading-snug"
                v-html="item?.preamble"
              ></div>
              <div
                class="custom-list prose lg:prose-lg prose-a:text-blue prose-a:no-underline hover:prose-a:text-blue-dark space-y-6 font-sans text-base leading-snug text-black lg:space-y-3 lg:text-lg lg:leading-snug"
                v-html="item?.copy"
              ></div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  </div>
</template>

<script setup lang="ts">
import Container from '../atoms/Container.vue'
import SubTitle from '../atoms/SubTitle.vue'
import Image from '../atoms/Image.vue'
import type { ICardData } from '../../types'

interface ICardDataZebra extends ICardData {
  preamble?: string
}

export interface IShortZebraBlock {
  id: string
  cards?: ICardDataZebra[]
}

interface Props {
  data: IShortZebraBlock
}

defineProps<Props>()
</script>
